import { render, staticRenderFns } from "./AppQuestion.vue?vue&type=template&id=33e7ba76&"
import script from "./AppQuestion.vue?vue&type=script&lang=js&"
export * from "./AppQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports